// The website's canonical form, trailing slash included, so links skip its redirect hop.
export function collectionPath(collectionId) {
    return `/collection/${encodeURIComponent(collectionId)}/`;
}

export function collectionCartPath(collectionId) {
    return `${collectionPath(collectionId)}cart/`;
}
